import api from "@/configs/axios-config";

export type Resource = {
  id: number;
  resource_key: string;
  display_name: string;
};

export const getAllResources = async (): Promise<Resource[]> => {
  const params = {
    skip: 0,
    limit: Number.MAX_SAFE_INTEGER,
  };

  const res = await api.get("/permission-management/resources/", { params });
  return res.data;
};

export type Action = {
  id: number;
  action_key: string;
  display_name: string;
};

export const getAllActions = async (): Promise<Action[]> => {
  const params = {
    skip: 0,
    limit: Number.MAX_SAFE_INTEGER,
  };

  const res = await api.get("/permission-management/actions/", { params });
  return res.data;
};

export type GroupResourceActionMapping = {
  group: {
    id: number;
    display_name: string;
    description: string;
  };
  resources: {
    resource: {
      id: number;
      display_name: string;
      description: string;
    };
    actions: {
      id: number;
      display_name: string;
      allowed: boolean;
    }[];
  }[];
};

export const getGroupResourceActionMapping = async (): Promise<GroupResourceActionMapping[]> => {
  const res = await api.get(
    "/permission-management/group-resource-action-mapping/"
  );
  return res.data.mapping;
};

export type createGroupParams = {
  group_key: string;
  display_name: string;
  description: string;
};

export const createGroup = async (params: createGroupParams) => {
  const res = await api.post("/permission-management/groups/", params);
  return res.data;
};

export type Group = {
  id: number;
  group_key: string;
  display_name: string;
  description: string;
  created_at: string;
};

export const getAllGroups = async (): Promise<Group[]> => {
  const params = {
    skip: 0,
    limit: Number.MAX_SAFE_INTEGER,
  };

  const res = await api.get("/permission-management/groups/", { params });
  return res.data;
};

export type UpdateGroupParams = {
  permissions: {
    group_id: number;
    resource_id: number;
    action_id: number;
    allowed: boolean;
  }[];
};

export const insertGroup = async (params: UpdateGroupParams) => {
  const res = await api.post("/permission-management/group-permissions/bulk", params);
  return res.data;
};

export const updateGroup = async (params: UpdateGroupParams) => {
  const res = await api.put("/permission-management/group-permissions/bulk", params);
  return res.data;
};